import { ReactNode } from "react";
import { TranslateProvider } from "./translation-provider";
import { DEFAULT_LOCALE, Locale } from "../config";
import useLocale from "../model/use-locale";

export function LocalizationProvider({
  children,
  locale: externalLocale,
}: {
  children: ReactNode;
  locale?: Locale;
}) {
  const { locale } = useLocale();

  return (
    <TranslateProvider locale={externalLocale ?? locale ?? DEFAULT_LOCALE}>
      {children}
    </TranslateProvider>
  );
}
